import React, { useContext } from 'react'
import Disclaimer from '../../../Sidebar/components/Disclaimer'

import { ReactComponent as Logo } from './icons/logo.svg'
import { AppConfigContext } from '../../../../context/AppConfig'
import VariantWrapper from '../../../VariantWrapper'
import { variants } from '../../../../constants/variant'

function MobileBottomSection({ modelLoading, className = '' }) {
  const { isOfficesApp, hide_disclaimer } = useContext(AppConfigContext)

  return (
    <>
      <div className={className} id="hey">
        <div className={`flex justify-between items-center px-[24px] mb-[10px] z-[40] mt-[5px]`}>
          <div className={`text-[12px] flex items-center ${modelLoading && !isOfficesApp ? 'opacity-0' : ''}`}>
            <span className="text-[#3D4256] opacity-60 mr-[3px]">Powered by</span>
            <Logo />
          </div>
          {!hide_disclaimer && <Disclaimer btnClassName="opacity-60 text-[#3D4256] font-medium" />}
        </div>
      </div>
    </>
  )
}

export default MobileBottomSection
